import { AloftPriceJSON } from '@aloft/toolkit-shared';
import { PayloadAction, isAnyOf } from '@reduxjs/toolkit';

import { PropertyDataSliceExtraReducer } from '../../../types.ts';
import { setOpinionOfSiteValue } from '../../actions/setOpinionOfSiteValue.ts';
import { propertyDataAdapter } from '../../propertyDataAdapter.ts';
import { setInitialOpinionOfSiteValue } from '../../thunks/setInitialOpinionOfSiteValue.ts';
import { setPerSf } from '../../thunks/setPerSf.ts';
import { getChangedEntityFromEditableData } from '../utils/getChangedEntityFromEditableData.ts';

export const setOpinionOfSiteValueExtraReducer: PropertyDataSliceExtraReducer = (builder) => {
  builder.addMatcher(
    isAnyOf(setOpinionOfSiteValue, setPerSf.fulfilled, setInitialOpinionOfSiteValue.fulfilled),
    (state, action: PayloadAction<AloftPriceJSON>) => {
      const { subject } = state.entities;
      if (!subject) return;

      propertyDataAdapter.updateOne(
        state,
        getChangedEntityFromEditableData(subject, { opinionOfSiteValue: action.payload }),
      );
    },
  );
};
